<template>
  <body class="login" cz-shortcut-listen="true">
    <TopBar />
    <div class="login__background login__background--invitation">
      <InfoColumn :data="infoColumn" />
      <FormColumn
        @submit-form="createAccount"
        :loading="loading"
        :invite="inviteData"
        :companyInput="companyInput"
      />
    </div>
  </body>
</template>

<script>
import TopBar from '@/components/Invitations/TopBar';
import InfoColumn from '@/components/Invitations/InfoColumn';
import FormColumn from '@/components/Invitations/FormColumn';
import { apiService } from '@/utils/api/index';
import { genericError, getListedError } from '@/utils/alerts.service';

export default {
  components: {
    TopBar,
    InfoColumn,
    FormColumn,
  },
  data() {
    return {
      infoColumn: {
        headline:
          'Give Partners the Correct Messaging for Your Public Profiles',
        firstStep: 'Create your PartnerPage account.',
        secondStep:
          'Complete your public profile and give partners the correct messaging',
        thirdStep:
          'Add partners and control messaging for all your public profiles',
      },
      loading: false,
      companyInput: {
        title: 'Company Name',
        name: 'agencyName',
        id: 'id_agency_name',
      },
      inviteData: {
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        inviteId: '',
        vendorId: '',
        vendorName: '',
      },
    };
  },
  async created() {
    const response = await apiService.get(
      `/dashboard_vendor/tech-partner/register/${this.$route.params.id}`
    );
    const {
      techPartnerCompanyName,
      techPartnerContactName,
      techPartnerContactEmail,
      id,
      vendorId,
      vendorName,
    } = response;
    this.inviteData.firstName = techPartnerContactName
      ? techPartnerContactName.split(' ')[0]
      : '';
    this.inviteData.lastName = techPartnerContactName
      ? techPartnerContactName.split(' ')[1]
      : '';
    this.inviteData.company = techPartnerCompanyName;
    this.inviteData.email = techPartnerContactEmail;
    this.inviteData.inviteId = id;
    this.inviteData.vendorId = vendorId;
    this.inviteData.vendorName = vendorName;
  },
  methods: {
    createAccount(data) {
      this.loading = true;
      apiService
        .post(
          `/dashboard_vendor/tech-partner/register/${this.$route.params.id}`,
          data
        )
        .then(response => {
          if (response.status < 400) {
            window.location.replace(
              `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/?accessToken=${response.data.auth0Response.accessToken}&idToken=${response.data.auth0Response.idToken}`
            );
          } else {
            if (response.data != undefined && response.data[0] != undefined) {
              genericError.message = response.data[0];
              this.$store.dispatch('showUserMessage', genericError);
            } else {
              var existingUserErr = getListedError;
              existingUserErr.setLink(
                `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/create_partner/${this.inviteData.inviteId}/${this.inviteData.vendorId}/${this.inviteData.vendorName}/vendor/`
              );
              this.$store.dispatch('showUserMessage', existingUserErr);
            }
            this.loading = false;
          }
        })
        .catch(e => {
          genericError.message = e.data[0];
          this.$store.dispatch('showUserMessage', genericError);
          this.loading = false;
        });
    },
  },
};
</script>
